import aquarius from '../../images/ast-aquarius.svg';
import aries from '../../images/ast-aries.svg';
import cancer from '../../images/ast-cancer.svg';
import capricorn from '../../images/ast-capricorn.svg';
import compatibilityImg from '../../images/ast-compatibility.svg';
import empty from '../../images/ast-empty.png';
import gemini from '../../images/ast-gemini.svg';
import leo from '../../images/ast-leo.svg';
import libra from '../../images/ast-libra.svg';
import pisces from '../../images/ast-pisces.svg';
import sagittarius from '../../images/ast-sagittarius.svg';
import scorpio from '../../images/ast-scorpio.svg';
import smallAquarius from '../../images/ast-small-aquarius.svg';
import smallAries from '../../images/ast-small-aries.svg';
import smallAscendant from '../../images/ast-small-ascendant.svg';
import smallCancer from '../../images/ast-small-cancer.svg';
import smallCapricorn from '../../images/ast-small-capricorn.svg';
import smallGemini from '../../images/ast-small-gemini.svg';
import smallLeo from '../../images/ast-small-leo.svg';
import smallLibra from '../../images/ast-small-libra.svg';
import smallPisces from '../../images/ast-small-pisces.svg';
import smallSagittarius from '../../images/ast-small-sagittarius.svg';
import smallScorpio from '../../images/ast-small-scorpio.svg';
import smallTaurus from '../../images/ast-small-taurus.svg';
import smallVirgo from '../../images/ast-small-virgo.svg';
import taurus from '../../images/ast-taurus.svg';
import virgo from '../../images/ast-virgo.svg';

import { compatibilitySummaries } from './compabilitySummaries';
import {
  ZodiacSignProps,
  CompatibilityZodiacSignsProps,
  MenuSelectOptionProps,
} from './interfaces';

export const ZodiacSignsUnselected = {
  value: 'default',
  display: 'Select a sign',
  image: empty,
  smallImage: empty,
  summary: '',
};

export const ZodiacSigns: ZodiacSignProps[] = [
  ZodiacSignsUnselected,
  {
    value: 'aquarius',
    display: 'Aquarius',
    dateRange: 'Jan 20th to Feb 18th',
    image: aquarius,
    smallImage: smallAquarius,
    summary:
      'Aquarians are known for their independent and progressive nature. They are often seen as innovative thinkers, highly intellectual, and deeply humanitarian, always striving for social change and equality.',
  },
  {
    value: 'aries',
    display: 'Aries',
    dateRange: 'Mar 21st to Apr 19th',
    image: aries,
    smallImage: smallAries,
    summary:
      'Aries individuals are known for their boldness, enthusiasm, and determination. They are natural leaders who thrive on challenges, often being adventurous, competitive, and full of energy, always ready to take on new ventures.',
  },
  {
    value: 'cancer',
    display: 'Cancer',
    dateRange: 'Jun 21st to Jul 22nd',
    image: cancer,
    smallImage: smallCancer,
    summary:
      'Cancerians are known for their nurturing and empathetic nature. They are highly intuitive, emotional, and protective of their loved ones, often exhibiting a strong sense of loyalty and devotion in their relationships.',
  },
  {
    value: 'capricorn',
    display: 'Capricorn',
    dateRange: 'Dec 22nd to Jan 19th',
    image: capricorn,
    smallImage: smallCapricorn,
    summary:
      'Capricorns are known for their ambition, discipline, and practicality. They are hardworking individuals with a strong sense of responsibility and perseverance, often striving for success and stability in all aspects of life.',
  },
  {
    value: 'gemini',
    display: 'Gemini',
    dateRange: 'May 21st to Jun 20th',
    image: gemini,
    smallImage: smallGemini,
    summary:
      'Geminis are known for their curiosity, versatility, and sociable nature. They are excellent communicators, adaptable, and intellectually curious, often displaying a dual personality that is both charming and complex.',
  },
  {
    value: 'leo',
    display: 'Leo',
    dateRange: 'Jul 23rd to Aug 22nd',
    image: leo,
    smallImage: smallLeo,
    summary:
      'Leos are known for their confidence, charisma, and leadership qualities. They are natural performers who enjoy being in the spotlight, often exhibiting generosity, warmth, and a strong sense of pride in their accomplishments.',
  },
  {
    value: 'libra',
    display: 'Libra',
    dateRange: 'Sep 23rd to Oct 22nd',
    image: libra,
    smallImage: smallLibra,
    summary:
      'Librans are known for their diplomacy, fairness, and harmony-seeking nature. They are skilled mediators who value peace and cooperation, often exhibiting a strong sense of justice and a desire for balance in all areas of life.',
  },
  {
    value: 'pisces',
    display: 'Pisces',
    dateRange: 'Feb 19th to Mar 20th',
    image: pisces,
    smallImage: smallPisces,
    summary:
      'Pisceans are known for their empathy, creativity, and dreamy nature. They are deeply intuitive, compassionate, and imaginative individuals, often displaying a strong connection to their emotions and the spiritual realm.',
  },
  {
    value: 'sagittarius',
    display: 'Sagittarius',
    dateRange: 'Nov 22nd to Dec 21st',
    image: sagittarius,
    smallImage: smallSagittarius,
    summary:
      'Sagittarians are known for their adventurous spirit, optimism, and philosophical outlook. They are seekers of truth and knowledge, often being open-minded, enthusiastic, and freedom-loving, always ready for new experiences.',
  },
  {
    value: 'scorpio',
    display: 'Scorpio',
    dateRange: 'Oct 23rd to Nov 21st',
    image: scorpio,
    smallImage: smallScorpio,
    summary:
      'Scorpios are known for their intensity, passion, and resourcefulness. They are deeply emotional and perceptive individuals, often exhibiting determination, loyalty, and a mysterious aura that draws others to them.',
  },
  {
    value: 'taurus',
    display: 'Taurus',
    dateRange: 'Apr 20th to May 20th',
    image: taurus,
    smallImage: smallTaurus,
    summary:
      'Taureans are known for their stability, reliability, and practicality. They are grounded individuals who value security and comfort, often exhibiting patience, loyalty, and a strong connection to nature and material pleasures.',
  },
  {
    value: 'virgo',
    display: 'Virgo',
    dateRange: 'Aug 23rd to Sep 22nd',
    image: virgo,
    smallImage: smallVirgo,
    summary:
      'Virgos are known for their analytical mind, attention to detail, and perfectionist tendencies. They are methodical and reliable individuals who excel in organization and problem-solving, often exhibiting a strong sense of duty and a desire for orderliness.',
  },
] as ZodiacSignProps[];

export const MenuOptions: { [key: string]: MenuSelectOptionProps } = {
  summary: {
    value: 'summary',
    display: 'Summary',
    summaryDisplay: 'Summary',
    category: 'Astrology',
    order: 0,
  },
  horoscope: {
    value: 'horoscope',
    display: 'Horoscope',
    summaryDisplay: 'Horoscope',
    category: 'Astrology',
    order: 1,
  },
  compatibility: {
    value: 'compatibility',
    display: 'Compatibility',
    summaryDisplay: 'Compatibility',
    category: 'Compatibility',
    startIconUrl: compatibilityImg,
    order: 3,
  },
  lifepath: {
    value: 'lifepath',
    display: 'Life Path',
    summaryDisplay: 'Numerology Lifepath',
    category: 'Numerology',
    order: 2,
  },
  personality: {
    value: 'personality',
    display: 'Personality Trait',
    summaryDisplay: 'Numerology Personality Trait',
    category: 'Numerology',
    order: 4,
  },
  ascendant: {
    value: 'ascendant',
    display: 'Rising/Ascendant',
    summaryDisplay: 'Rising Sign/Ascendant',
    category: 'Rising Sign',
    startIconUrl: smallAscendant,
    order: 5,
  },
};

export const GetCompatibilityZodiacSigns = () => {
  return {
    aquarius: {
      aquarius: {
        compatibility: 45,
        summary: compatibilitySummaries.aquarius.aquarius,
      },
      aries: {
        compatibility: 78,
        summary: compatibilitySummaries.aquarius.aries,
      },
      cancer: {
        compatibility: 27,
        summary: compatibilitySummaries.aquarius.cancer,
      },
      capricorn: {
        compatibility: 68,
        summary: compatibilitySummaries.aquarius.capricorn,
      },
      gemini: {
        compatibility: 85,
        summary: compatibilitySummaries.aquarius.gemini,
      },
      leo: {
        compatibility: 68,
        summary: compatibilitySummaries.aquarius.leo,
      },
      libra: {
        compatibility: 90,
        summary: compatibilitySummaries.aquarius.libra,
      },
      pisces: {
        compatibility: 45,
        summary: compatibilitySummaries.aquarius.pisces,
      },
      sagittarius: {
        compatibility: 90,
        summary: compatibilitySummaries.aquarius.sagittarius,
      },
      scorpio: {
        compatibility: 73,
        summary: compatibilitySummaries.aquarius.scorpio,
      },
      taurus: {
        compatibility: 58,
        summary: compatibilitySummaries.aquarius.taurus,
      },
      virgo: {
        compatibility: 30,
        summary: compatibilitySummaries.aquarius.virgo,
      },
    },
    aries: {
      aquarius: {
        compatibility: 78,
        summary: compatibilitySummaries.aries.aquarius,
      },
      aries: {
        compatibility: 50,
        summary: compatibilitySummaries.aries.aries,
      },
      cancer: {
        compatibility: 42,
        summary: compatibilitySummaries.aries.cancer,
      },
      capricorn: {
        compatibility: 47,
        summary: compatibilitySummaries.aries.capricorn,
      },
      gemini: {
        compatibility: 83,
        summary: compatibilitySummaries.aries.gemini,
      },
      leo: {
        compatibility: 97,
        summary: compatibilitySummaries.aries.leo,
      },
      libra: {
        compatibility: 85,
        summary: compatibilitySummaries.aries.libra,
      },
      pisces: {
        compatibility: 67,
        summary: compatibilitySummaries.aries.pisces,
      },
      sagittarius: {
        compatibility: 93,
        summary: compatibilitySummaries.aries.sagittarius,
      },
      scorpio: {
        compatibility: 50,
        summary: compatibilitySummaries.aries.scorpio,
      },
      taurus: {
        compatibility: 38,
        summary: compatibilitySummaries.aries.taurus,
      },
      virgo: {
        compatibility: 63,
        summary: compatibilitySummaries.aries.virgo,
      },
    },
    cancer: {
      aquarius: {
        compatibility: 27,
        summary: compatibilitySummaries.cancer.aquarius,
      },
      aries: {
        compatibility: 42,
        summary: compatibilitySummaries.cancer.aries,
      },
      cancer: {
        compatibility: 75,
        summary: compatibilitySummaries.cancer.cancer,
      },
      capricorn: {
        compatibility: 83,
        summary: compatibilitySummaries.cancer.capricorn,
      },
      gemini: {
        compatibility: 65,
        summary: compatibilitySummaries.cancer.gemini,
      },
      leo: {
        compatibility: 35,
        summary: compatibilitySummaries.cancer.leo,
      },
      libra: {
        compatibility: 43,
        summary: compatibilitySummaries.cancer.libra,
      },
      pisces: {
        compatibility: 98,
        summary: compatibilitySummaries.cancer.pisces,
      },
      sagittarius: {
        compatibility: 53,
        summary: compatibilitySummaries.cancer.sagittarius,
      },
      scorpio: {
        compatibility: 94,
        summary: compatibilitySummaries.cancer.scorpio,
      },
      taurus: {
        compatibility: 97,
        summary: compatibilitySummaries.cancer.taurus,
      },
      virgo: {
        compatibility: 90,
        summary: compatibilitySummaries.cancer.virgo,
      },
    },
    capricorn: {
      aquarius: {
        compatibility: 68,
        summary: compatibilitySummaries.capricorn.aquarius,
      },
      aries: {
        compatibility: 47,
        summary: compatibilitySummaries.capricorn.aries,
      },
      cancer: {
        compatibility: 83,
        summary: compatibilitySummaries.capricorn.cancer,
      },
      capricorn: {
        compatibility: 75,
        summary: compatibilitySummaries.capricorn.capricorn,
      },
      gemini: {
        compatibility: 68,
        summary: compatibilitySummaries.capricorn.gemini,
      },
      leo: {
        compatibility: 35,
        summary: compatibilitySummaries.capricorn.leo,
      },
      libra: {
        compatibility: 55,
        summary: compatibilitySummaries.capricorn.libra,
      },
      pisces: {
        compatibility: 88,
        summary: compatibilitySummaries.capricorn.pisces,
      },
      sagittarius: {
        compatibility: 60,
        summary: compatibilitySummaries.capricorn.sagittarius,
      },
      scorpio: {
        compatibility: 95,
        summary: compatibilitySummaries.capricorn.scorpio,
      },
      taurus: {
        compatibility: 98,
        summary: compatibilitySummaries.capricorn.taurus,
      },
      virgo: {
        compatibility: 95,
        summary: compatibilitySummaries.capricorn.virgo,
      },
    },
    gemini: {
      aquarius: {
        compatibility: 85,
        summary: compatibilitySummaries.gemini.aquarius,
      },
      aries: {
        compatibility: 83,
        summary: compatibilitySummaries.gemini.aries,
      },
      cancer: {
        compatibility: 65,
        summary: compatibilitySummaries.gemini.cancer,
      },
      capricorn: {
        compatibility: 68,
        summary: compatibilitySummaries.gemini.capricorn,
      },
      gemini: {
        compatibility: 60,
        summary: compatibilitySummaries.gemini.gemini,
      },
      leo: {
        compatibility: 88,
        summary: compatibilitySummaries.gemini.leo,
      },
      libra: {
        compatibility: 93,
        summary: compatibilitySummaries.gemini.libra,
      },
      pisces: {
        compatibility: 53,
        summary: compatibilitySummaries.gemini.pisces,
      },
      sagittarius: {
        compatibility: 60,
        summary: compatibilitySummaries.gemini.sagittarius,
      },
      scorpio: {
        compatibility: 28,
        summary: compatibilitySummaries.gemini.scorpio,
      },
      taurus: {
        compatibility: 33,
        summary: compatibilitySummaries.gemini.taurus,
      },
      virgo: {
        compatibility: 68,
        summary: compatibilitySummaries.gemini.virgo,
      },
    },
    leo: {
      aquarius: {
        compatibility: 68,
        summary: compatibilitySummaries.leo.aquarius,
      },
      aries: {
        compatibility: 97,
        summary: compatibilitySummaries.leo.aries,
      },
      cancer: {
        compatibility: 35,
        summary: compatibilitySummaries.leo.cancer,
      },
      capricorn: {
        compatibility: 35,
        summary: compatibilitySummaries.leo.capricorn,
      },
      gemini: {
        compatibility: 88,
        summary: compatibilitySummaries.leo.gemini,
      },
      leo: {
        compatibility: 45,
        summary: compatibilitySummaries.leo.leo,
      },
      libra: {
        compatibility: 97,
        summary: compatibilitySummaries.leo.libra,
      },
      pisces: {
        compatibility: 38,
        summary: compatibilitySummaries.leo.pisces,
      },
      sagittarius: {
        compatibility: 93,
        summary: compatibilitySummaries.leo.sagittarius,
      },
      scorpio: {
        compatibility: 58,
        summary: compatibilitySummaries.leo.scorpio,
      },
      taurus: {
        compatibility: 73,
        summary: compatibilitySummaries.leo.taurus,
      },
      virgo: {
        compatibility: 35,
        summary: compatibilitySummaries.leo.virgo,
      },
    },
    libra: {
      aquarius: {
        compatibility: 90,
        summary: compatibilitySummaries.libra.aquarius,
      },
      aries: {
        compatibility: 85,
        summary: compatibilitySummaries.libra.aries,
      },
      cancer: {
        compatibility: 43,
        summary: compatibilitySummaries.libra.cancer,
      },
      capricorn: {
        compatibility: 55,
        summary: compatibilitySummaries.libra.capricorn,
      },
      gemini: {
        compatibility: 93,
        summary: compatibilitySummaries.libra.gemini,
      },
      leo: {
        compatibility: 97,
        summary: compatibilitySummaries.libra.leo,
      },
      libra: {
        compatibility: 75,
        summary: compatibilitySummaries.libra.libra,
      },
      pisces: {
        compatibility: 88,
        summary: compatibilitySummaries.libra.pisces,
      },
      sagittarius: {
        compatibility: 73,
        summary: compatibilitySummaries.libra.sagittarius,
      },
      scorpio: {
        compatibility: 35,
        summary: compatibilitySummaries.libra.scorpio,
      },
      taurus: {
        compatibility: 65,
        summary: compatibilitySummaries.libra.taurus,
      },
      virgo: {
        compatibility: 68,
        summary: compatibilitySummaries.libra.virgo,
      },
    },
    pisces: {
      aquarius: {
        compatibility: 45,
        summary: compatibilitySummaries.pisces.aquarius,
      },
      aries: {
        compatibility: 67,
        summary: compatibilitySummaries.pisces.aries,
      },
      cancer: {
        compatibility: 98,
        summary: compatibilitySummaries.pisces.cancer,
      },
      capricorn: {
        compatibility: 88,
        summary: compatibilitySummaries.pisces.capricorn,
      },
      gemini: {
        compatibility: 53,
        summary: compatibilitySummaries.pisces.gemini,
      },
      leo: {
        compatibility: 38,
        summary: compatibilitySummaries.pisces.leo,
      },
      libra: {
        compatibility: 88,
        summary: compatibilitySummaries.pisces.libra,
      },
      pisces: {
        compatibility: 60,
        summary: compatibilitySummaries.pisces.pisces,
      },
      sagittarius: {
        compatibility: 63,
        summary: compatibilitySummaries.pisces.sagittarius,
      },
      scorpio: {
        compatibility: 97,
        summary: compatibilitySummaries.pisces.scorpio,
      },
      taurus: {
        compatibility: 85,
        summary: compatibilitySummaries.pisces.taurus,
      },
      virgo: {
        compatibility: 88,
        summary: compatibilitySummaries.pisces.virgo,
      },
    },
    sagittarius: {
      aquarius: {
        compatibility: 90,
        summary: compatibilitySummaries.sagittarius.aquarius,
      },
      aries: {
        compatibility: 93,
        summary: compatibilitySummaries.sagittarius.aries,
      },
      cancer: {
        compatibility: 53,
        summary: compatibilitySummaries.sagittarius.cancer,
      },
      capricorn: {
        compatibility: 60,
        summary: compatibilitySummaries.sagittarius.capricorn,
      },
      gemini: {
        compatibility: 60,
        summary: compatibilitySummaries.sagittarius.gemini,
      },
      leo: {
        compatibility: 93,
        summary: compatibilitySummaries.sagittarius.leo,
      },
      libra: {
        compatibility: 73,
        summary: compatibilitySummaries.sagittarius.libra,
      },
      pisces: {
        compatibility: 63,
        summary: compatibilitySummaries.sagittarius.pisces,
      },
      sagittarius: {
        compatibility: 45,
        summary: compatibilitySummaries.sagittarius.sagittarius,
      },
      scorpio: {
        compatibility: 28,
        summary: compatibilitySummaries.sagittarius.scorpio,
      },
      taurus: {
        compatibility: 30,
        summary: compatibilitySummaries.sagittarius.taurus,
      },
      virgo: {
        compatibility: 48,
        summary: compatibilitySummaries.sagittarius.virgo,
      },
    },
    scorpio: {
      aquarius: {
        compatibility: 73,
        summary: compatibilitySummaries.scorpio.aquarius,
      },
      aries: {
        compatibility: 50,
        summary: compatibilitySummaries.scorpio.aries,
      },
      cancer: {
        compatibility: 94,
        summary: compatibilitySummaries.scorpio.cancer,
      },
      capricorn: {
        compatibility: 95,
        summary: compatibilitySummaries.scorpio.capricorn,
      },
      gemini: {
        compatibility: 28,
        summary: compatibilitySummaries.scorpio.gemini,
      },
      leo: {
        compatibility: 58,
        summary: compatibilitySummaries.scorpio.leo,
      },
      libra: {
        compatibility: 35,
        summary: compatibilitySummaries.scorpio.libra,
      },
      pisces: {
        compatibility: 97,
        summary: compatibilitySummaries.scorpio.pisces,
      },
      sagittarius: {
        compatibility: 28,
        summary: compatibilitySummaries.scorpio.sagittarius,
      },
      scorpio: {
        compatibility: 80,
        summary: compatibilitySummaries.scorpio.scorpio,
      },
      taurus: {
        compatibility: 88,
        summary: compatibilitySummaries.scorpio.taurus,
      },
      virgo: {
        compatibility: 88,
        summary: compatibilitySummaries.scorpio.virgo,
      },
    },
    taurus: {
      aquarius: {
        compatibility: 58,
        summary: compatibilitySummaries.taurus.aquarius,
      },
      aries: {
        compatibility: 38,
        summary: compatibilitySummaries.taurus.aries,
      },
      cancer: {
        compatibility: 97,
        summary: compatibilitySummaries.taurus.cancer,
      },
      capricorn: {
        compatibility: 98,
        summary: compatibilitySummaries.taurus.capricorn,
      },
      gemini: {
        compatibility: 33,
        summary: compatibilitySummaries.taurus.gemini,
      },
      leo: {
        compatibility: 73,
        summary: compatibilitySummaries.taurus.leo,
      },
      libra: {
        compatibility: 65,
        summary: compatibilitySummaries.taurus.libra,
      },
      pisces: {
        compatibility: 85,
        summary: compatibilitySummaries.taurus.pisces,
      },
      sagittarius: {
        compatibility: 30,
        summary: compatibilitySummaries.taurus.sagittarius,
      },
      scorpio: {
        compatibility: 88,
        summary: compatibilitySummaries.taurus.scorpio,
      },
      taurus: {
        compatibility: 65,
        summary: compatibilitySummaries.taurus.taurus,
      },
      virgo: {
        compatibility: 90,
        summary: compatibilitySummaries.taurus.virgo,
      },
    },
    virgo: {
      aquarius: {
        compatibility: 30,
        summary: compatibilitySummaries.virgo.aquarius,
      },
      aries: {
        compatibility: 63,
        summary: compatibilitySummaries.virgo.aries,
      },
      cancer: {
        compatibility: 90,
        summary: compatibilitySummaries.virgo.cancer,
      },
      capricorn: {
        compatibility: 95,
        summary: compatibilitySummaries.virgo.capricorn,
      },
      gemini: {
        compatibility: 68,
        summary: compatibilitySummaries.virgo.gemini,
      },
      leo: {
        compatibility: 35,
        summary: compatibilitySummaries.virgo.leo,
      },
      libra: {
        compatibility: 68,
        summary: compatibilitySummaries.virgo.libra,
      },
      pisces: {
        compatibility: 88,
        summary: compatibilitySummaries.virgo.pisces,
      },
      sagittarius: {
        compatibility: 48,
        summary: compatibilitySummaries.virgo.sagittarius,
      },
      scorpio: {
        compatibility: 88,
        summary: compatibilitySummaries.virgo.scorpio,
      },
      taurus: {
        compatibility: 90,
        summary: compatibilitySummaries.virgo.taurus,
      },
      virgo: {
        compatibility: 65,
        summary: compatibilitySummaries.virgo.virgo,
      },
    },
  } as CompatibilityZodiacSignsProps;
};
